export default "__VITE_ASSET__CRXuif$F__"